import { useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import RouteAnimationContext from 'animations/routeAnimationContext'

type RedirectAnimationProps = {
  to: string
  delay: number
}

const useRedirectAnimation = ({ to, delay }: RedirectAnimationProps) => {
  const { setAnimationRun, setAnimationHalfLife } = useContext(RouteAnimationContext)

  let halfLifeAnimationTimeout: any
  let endAnimationTimeout: any

  const history = useHistory()
  const location = useLocation()

  useEffect(
    () => () => {
      clearTimeout(halfLifeAnimationTimeout)
      clearTimeout(endAnimationTimeout)
    },
    [halfLifeAnimationTimeout, endAnimationTimeout]
  )

  function handleRedirectAnimation(e?: React.MouseEvent) {
    // if trying to navigate to current page stop everything
    if (`${location.pathname}${location.search}` === to) return

    setAnimationRun(true)
    if (e) e.preventDefault()

    halfLifeAnimationTimeout = setTimeout(() => {
      history.push(to)
      setAnimationHalfLife(true)
    }, delay)

    endAnimationTimeout = setTimeout(() => {
      setAnimationRun(false)
      setAnimationHalfLife(false)
    }, delay * 2)
  }

  return handleRedirectAnimation
}

export default useRedirectAnimation
